/**
 * handle incomming messages
 * Method is triggered when Iframe sends message to set height
 */
export default function handleCrossOriginMessage(e) {
  let el = null;
  const targetHeight = e.data.height;
  if (e.data.action === "RESIZE_IFRAME_LOGIN") {
    el = $("#abo-banner-iframe");
  } else if (e.data.action === "RESIZE_IFRAME_TOP") {
    el = $("#tw_iframe_top");
  } else if (e.data.action === "RESIZE_IFRAME_ARCHIVE") {
    el = $("#iframeArchive");
  } else if (e.data.action === "RESIZE_IFRAME_BOTTOM") {
    el = $("#tw_iframe_bottom");
  } else if (e.data.action === "RESIZE_IFRAME_ARCHIVE_BOTTOM") {
    el = $("#iframeArchiveBottom");
  }

  if (el !== null) {
    // if (targetHeight > 10) // only add extra spacing if there is sufficient height with content
    // targetHeight = targetHeight + 50;
    el.height(targetHeight);
  }
}



// WEBPACK FOOTER //
// ./src/common/utilities/iframeUtils.js